import { PENDING, REJECTED, FULFILLED } from '../../helpers/reduxPromiseMiddleware'

import * as ActionTypes from '../../constants/ActionType'
import EntityFacade from '../../facades/entity'

export default {
  [ActionTypes.LOAD_BROADCAST_CHANNELS]: {
    [PENDING](state, { payload }) {
      return EntityFacade(state)
        .startLoadingEntity('broadcastChannels')
        .get()
    },
    [FULFILLED](state, { payload }) {
      const { broadcastChannels } = payload
      return EntityFacade(state)
        .loadBroadcastChannels(broadcastChannels)
        .finishLoadingEntity('broadcastChannels')
        .get()
    },
    [REJECTED](state, { payload }) {
      return EntityFacade(state)
        .loadBroadcastChannels([])
        .finishLoadingEntity('broadcastChannels')
        .get()
    }
  }
}
